<div class="configuration-commitments-commitments-view-part">
	<commitments-grid [service]="pageService" [rows]="commitments()"></commitments-grid>
</div>